import { render, staticRenderFns } from "./MyTab.vue?vue&type=template&id=f74a5212&scoped=true"
import script from "./MyTab.vue?vue&type=script&lang=js"
export * from "./MyTab.vue?vue&type=script&lang=js"
import style0 from "./MyTab.vue?vue&type=style&index=0&id=f74a5212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74a5212",
  null
  
)

export default component.exports